/* InfoBox — design `.alert` */
.infoBox {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  padding: 13px 16px;
  border-radius: 11px;
  font-size: var(--font-size-m);
  line-height: 1.5;
}

.infoIcon {
  flex: 0 0 auto;
  display: inline-flex;
  margin-top: 1px;
}

.infoBody {
  min-width: 0;
}

.tone-info {
  background: var(--color-grey-lightest);
  color: var(--color-text);
}

.tone-primary {
  background: var(--color-primary-lightest);
  color: var(--color-primary-dark);
}

.tone-warning {
  background: var(--color-warning-lightest);
  color: var(--color-warning);
}

.tone-success {
  background: var(--color-success-lightest);
  color: var(--color-success);
}

.tone-error {
  background: var(--color-error-lightest);
  color: var(--color-error);
}
